import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img26 from "../../About/images/26.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person26 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img26} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Крыкбаева Марьям Сергазиновна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Бакалавр экономики и бизнеса, MBA
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57956316000'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0001-7808-8650'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        НАО «Торайгыров университет», директор Научно-инновационного HUB, старший преподаватель кафедры «Финансы и учет»
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ведение финансовой документации по проекту.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Имеет опыт научно-исследовательской работы в рамках хоздоговорных и грантовых тем. Обладает навыками в проектной деятельности и финансовом сопровождении научных проектов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте грантового финансирования на 2018-2020 гг. ИРН AP05132859 «Исследование особенностей природно-ресурсного потенциала соленых озер Павлодарской области для разработки и внедрения нетрадиционных иновационно-технологических методов по созданию управляемых артемиевых хозяйств». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте грантового финансирования на 2018-2020 гг. ИРН AP05131846 «Повышение ресурсоэффективности технологий производства высокооктановых бензинов, дизельного топлива и жирных газов на установках каталитического крекинга, риформинга и изомеризации». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте грантового финансирования на 2021-2023 гг. ИРН AP09058450 «Разработка экологической системы фитосанитарного контроля деструктивной биоты (фитофагов и фитопатогенов) яровой пшеницы на Северо-Востоке Казахстана.». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Участвует в проекте грантового финансирования на 2024-2026 гг. ИРН AP23484991 «Повышение культурной толерантности и религиозной грамотности молодежи в условиях модернизации общественного сознания современного Казахстана». Роль –исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований, написание научных статей.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Zhalmagambetova U., Radelyuk I., Krykbayeva M., Biloshchytska S., Kirichenko L. Development of an automatic monitoring system based on the open architecture concept. «Вестник Торайгыров университета. Серия энергетическая», № 2, 2024, с. 112–125. DOI: https://doi.org/10.48081/BMOM3785
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Мапитов Н.Б. и др. Экология: учебное пособие. Павлодар: Toraighyrov University, 2024. – 155 с. ISBN 978-601-345-556-3
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Сергазинова З.М. и др. «Экологиялық мониторинг: лекциялар курсы» оқу құралы. Павлодар: Toraighyrov University, 2024. – 95 с. ISBN 978-601-345-571-6
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    4. Кириченко Л.Н., Жалмагамбетова У.К., Командиров Е.В., Шимпф А.А. Методы определения эмиссий от основных стационарных источников загрязнений. «Вестник Торайгыров университета. Серия энергетическая», № 3, 2024, с. 167–185. DOI: https://doi.org/10.48081/HRWJ4394
                </MyText>
            </Flex>
        </Flex>
    );
}